import { BuySpecs } from '@etoh/database/core';

// TODO: maybe, should take in consideration the agreements status
export function isAgreementLost(buySpec: BuySpecs): boolean {
  return (
    buySpec?.archivedAt &&
    new Date(buySpec.createdAt).getFullYear() >= 2023 &&
    !buySpec?.agreementsIds?.length
  );
}

export function isAgreementFinished(buySpec: BuySpecs): boolean {
  return !!buySpec?.agreements?.find(
    (a) => a.contractStatus === 'approvedByParties'
  );
}

export function isAgreementInProgress(buySpec: BuySpecs): boolean {
  if (!buySpec?.agreementsIds?.length) {
    return false;
  }

  return !isAgreementFinished(buySpec);
}
